import { hasRole, isDarkMode, useHub } from "../../../../../core/Global";
import Job from "../../models/Job";
import FlexRow from "../../../../../components/base/FlexRow";
import Icon from "../../../../../components/base/Icon";
import IconButton from "../../../../../components/base/IconButton";
import { TagifyDataItem } from "../../../../../models/TagifyOptions";
import { API_ROUTES } from "../../../../../core/Constants";
import { TagCompact } from "../../../base/models/TagItem";
import JobAddTag from "../JobAddTag";



interface IProps {
    job: Job
}
export default function JobDrawerTags(props: IProps) {


    const hub = useHub()


    return (
        <FlexRow>
            <div>
                <div className="text-muted fs-8">
                    <Icon icon="tag" size={10} className="me-2" type="solid" />
                    Tags
                </div>
                <FlexRow className="ps-5 mt-2" wrap>
                    {
                        props.job.tags?.map((item, k) =>
                            <span key={k} className="badge badge-secondary me-1 mb-1"
                                style={{
                                    backgroundColor: isDarkMode() ? undefined : "rgb(227 227 231)"
                                }}>
                                {item.name}
                                {
                                    (!props.job.isArchived || hasRole("EditArchivedJobs")) &&
                                    <a href="#" className="ps-2" title="Remove Tag"
                                        onClick={e => {
                                            e.preventDefault();
                                            hub.Post(API_ROUTES.Jobs + "removetag", {
                                                jobId: props.job.id,
                                                tagId: item.id
                                            }, res => { })
                                        }}>
                                        <Icon icon="times" className="text-muted fs-8" />
                                    </a>
                                }

                            </span>
                        )
                    }

                    <JobAddTag job={props.job} tags />


                </FlexRow>
            </div>
            <FlexRow className="flex-grow-1" justify="end">

            </FlexRow>
        </FlexRow>
    )
}